import { ApiConfigs, Response } from '@schemas/service';

import { request } from './request';

const api: ApiConfigs = {
  queryContentAuthorizationStatus: {
    url: '/health/api/v1/doctor/authorization',
    method: 'POST'
  },
  queryEnterContentAuthorizationStatus: {
    url: '/health/api/v1/doctor/queryAuthorization',
    method: 'GET'
  }
};

const contentAuthorizationOperation = {
  async getContentAuthorization(action) {
    try {
      const response: Response<boolean> = await request(
        api.queryContentAuthorizationStatus,
        action
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getEnterAuthorizationStatus() {
    try {
      const response: Response<boolean> = await request(
        api.queryEnterContentAuthorizationStatus,
        undefined,
        undefined,
        { hideToast: true }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default contentAuthorizationOperation;
